/* global __API_ROOT_URL__ */
import angular from 'angular';
import constants from 'app/constants';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';


let _$http;
let _utilityService;

class controlDataService {
  constructor(
    $http,
    Upload,
    utilityService // eslint-disable-line no-shadow
  ) {
    _$http = $http;
    _utilityService = utilityService;

    console.log('app.services.controlDataService created');
  }

  init() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControlAdministration/init`,
      method: 'GET',
      params: {}
    });
  }

  initControlAdmin() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControlAdministration/initCustomerControlAdministration`,
      method: 'GET',
      params: {}
    });
  }

  getControlTypes() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControlType`,
      method: 'GET',
    });
  }

  getControlType(controlTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControlType/${controlTypeId}`,
      method: 'GET',
    });
  }

  getCustomerInitControlTypeControls(controlTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerInitControlType/${controlTypeId}`,
      method: 'GET',
    });
  }

  getControls() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControl`,
      method: 'GET',
    });
  }

  getControl(controlId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControl/${controlId}`,
      method: 'GET',
      // params: { includeControls: true }
    });
  }

  getControlById(controlId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControl/editControlData/${controlId}`,
      method: 'GET',
      // params: { includeControls: true }
    });
  }

  getControlTypeDefaults() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControlType/default`,
      method: 'GET',
    });
  }

  getControlWeights() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControlWeight`,
      method: 'GET',
    });
  }

  checkControlTypeNameExists(customerControlTypeId, displayValue) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControlType/checkExists`,
      method: 'GET',
      params: {
        name: displayValue,
        id: customerControlTypeId,
      },
    });
  }

  checkControlNameExists(displayValue, customerControlId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControl/checkExists`,
      method: 'GET',
      params: {
        name: displayValue,
        id: customerControlId,
      },
    });
  }

  saveControlType(controlType) {
    let _url = `${__API_ROOT_URL__}/ent/customerControlType`;
    let _method = 'POST';

    if (controlType.customerControlTypeId > 0) {
      _url = `${__API_ROOT_URL__}/ent/customerControlType/${controlType.customerControlTypeId}`;
      _method = 'PUT';
    }

    return _$http({
      url: _url,
      method: _method,
      data: JSON.stringify(controlType),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  saveControl(control) {
    let _url = `${__API_ROOT_URL__}/ent/customerControl`;
    let _method = 'POST';

    if (control.customerControlId > 0) {
      _url = `${__API_ROOT_URL__}/ent/customerControl/${control.customerControlId}`;
      _method = 'PUT';
    }

    return _$http({
      url: _url,
      method: _method,
      data: JSON.stringify(control),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  saveControlSettings(settings) {
    const _url = `${__API_ROOT_URL__}/ent/controlAdministrationSettings`;
    const _method = 'POST';

    return _$http({
      url: _url,
      method: _method,
      data: JSON.stringify(settings),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  deleteControlType(controlTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControlType/${controlTypeId}`,
      method: 'DELETE',
    });
  }

  deleteCustomerControl(controlId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControl/${controlId}`,
      method: 'DELETE',
    });
  }

  unAssignControlType(assetTypeId, riskControlTypeId, controlTypes) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssetType/${assetTypeId}/risk/${riskControlTypeId}/deleteControl`,
      method: 'PUT',
      data: JSON.stringify(controlTypes),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
    // return _$http({
    //   url: `${__API_ROOT_URL__}/ent/customerRiskTypeCustomerControlType/${riskControlTypeId}/${controlTypeId}`,
    //   method: 'DELETE',
    // });
  }

  unAssignControlsFromRisk(customerRiskControlId) {
    const _url = `${__API_ROOT_URL__}/ent/customerRisk/unassign/${customerRiskControlId}`;
    const _method = 'PUT';

    return _$http({
      url: _url,
      method: _method,
      data: null,
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  bulkDeleteControls(idList) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControl/bulkDelete`,
      method: 'PUT',
      data: JSON.stringify(idList),
      params: { echo: true, },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  syncControl(controlSyncDTO) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControl/syncToCustomerControlType`,
      method: 'PUT',
      data: JSON.stringify(controlSyncDTO),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }
}

controlDataService.$inject = ['$http', 'Upload', 'utilityService'];
export default angular.module('app.services.controlDataService', [
  ngFileUpload,
  constants,
])
  .service('controlDataService', controlDataService)
  .name;
